export default __webpack_public_path__ + "static/media/icon-banner-default.ae2a5c60.png";